import { ShippingCost } from "src/components/product/components/ShippingCost"
import { ShippingDate } from "src/components/product/components/ShippingDate"
import { ShippingInfo } from "src/components/product/components/ShippingInfo"
import { StorefrontDetailProduct, StorefrontDetailVariant } from "src/types/storefront"

export type ProductPriceProps = {
  product: StorefrontDetailProduct
  variant: StorefrontDetailVariant | undefined
}

export function ProductShippingInfo({ product, variant }: ProductPriceProps) {
  const initializing = !variant
  const pricing = variant?.pricing || product.variants[0]?.pricing

  return (
    <ShippingInfo initializing={initializing} variant={variant} highlightFreeShipping>
      <ShippingCost price={pricing?.calculatedPrice || 0} />
      <ShippingDate product={product} variant={variant} />
    </ShippingInfo>
  )
}
